import { Button } from "@mui/material";
import { motion } from "framer-motion";

function RSVPButton({ mt = 0, onAnimationComplete }) {
  return (
    <Button
      component={motion.a}
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
      onAnimationComplete={onAnimationComplete}
      whileHover={{ scale: 1.02, y: -2 }}
      whileTap={{ scale: 0.98 }}
      href="https://forms.gle/ZDjQNBD6uA3DNEHs9"
      target="_blank"
      rel="noopener noreferrer"
      variant="contained"
      sx={{
        backgroundColor: "#1a3a52",
        color: "#faf4e9",
        fontFamily: '"Open Sans", sans-serif',
        fontSize: { xs: "0.95rem", sm: "1rem" },
        fontWeight: 500,
        letterSpacing: "1px",
        textTransform: "uppercase",
        px: { xs: 4, sm: 5 },
        py: { xs: 1, sm: 1.25 },
        borderRadius: 1,
        boxShadow: "0 2px 8px rgba(26,58,82,0.2)",
        "&:hover": {
          backgroundColor: "#2d4e66",
          boxShadow: "0 4px 12px rgba(26,58,82,0.3)",
        },
        mt: mt,
        transition: "all 0.3s ease",
      }}
    >
      RSVP
    </Button>
  );
}

export default RSVPButton;
